"use strict";

var _Symbol$iterator = require("@babel/runtime-corejs3/core-js/symbol/iterator");

var _Symbol = require("@babel/runtime-corejs3/core-js/symbol");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _context, _context2, _context3;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  api: true
};
exports.default = exports.api = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _duration = _interopRequireDefault(require("dayjs/plugin/duration"));

var _isoWeek = _interopRequireDefault(require("dayjs/plugin/isoWeek"));

var api = _interopRequireWildcard(require("./api"));

exports.api = api;

var WebUtils = _interopRequireWildcard(require("./utils"));

_forEachInstanceProperty(_context = _Object$keys(WebUtils)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === WebUtils[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return WebUtils[key];
    }
  });
});

var _rem = require("./rem");

_forEachInstanceProperty(_context2 = _Object$keys(_rem)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _rem[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rem[key];
    }
  });
});

var _types = require("./types");

_forEachInstanceProperty(_context3 = _Object$keys(_types)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dayjs.default.extend(_duration.default);

_dayjs.default.extend(_isoWeek.default); // TODO: 2021/11/12 sweetliquid 等所有仓库的 TypeScript 都升级至 4.2 及以上版本后，可以简化为
//   `export * as api from './api'`


var _default = WebUtils;
exports.default = _default;